export function BrandMark() {
  return (
    <svg
      className="brand-mark"
      viewBox="0 0 36 28"
      width="36"
      height="28"
      aria-hidden="true"
      focusable="false"
    >
      <path className="brand-mark__paper" d="M8 1.5h20v8H8z" />
      <path className="brand-mark__envelope" d="M1.5 6.5h33v20h-33z" />
      <path className="brand-mark__flap" d="M2.5 7.5 18 19 33.5 7.5" />
      <path className="brand-mark__seam" d="m2.5 25.5 10.8-10.4M33.5 25.5 22.7 15.1" />
    </svg>
  );
}
